import AddBoxIcon from '@mui/icons-material/AddBox'
import { Box, IconButton, TableCell, TableRow, Tooltip, Typography } from '@mui/material'
import { clinicTheme } from 'api/api'
import _ from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

/** UTILS || SLICE */
import { handleShow, resetModal, showModal } from 'app/slice/modal.slice'
import { isEditTootChart, isEditTootChartType, loadPromotionTreatments, ProductStickerType, setColorToothChart, setEditTootChart, setEditTootChartType, setSubmitTootChart, setTreatmentByKey, StickerType, treatment, TreatmentStateInterface } from 'app/slice/treatment.slice'
import { getBranch, getClinicInfo, numberFormat } from 'utils/app.utils'
import useWindowSize from 'utils/useWindowSize'

/** API */
import ComponentApi, { Bookmark } from 'api/components-api'
import TreatmentApi from 'api/dentists/treatment.api'
import { DiagnosisDataInterface, DxRecommendDataInterface } from 'api/setting/treatments/diagnosis.api'

/** CONSTANTS */
import { Icons } from 'constants/images'
import { colors } from 'constants/theme'

/** COMPONENT */
import InputTextSearch from 'component/Input/InputTextSearch'
import Loading from 'component/Loading'
import ToothChart from 'component/ToothChart/ToothChart'
import PopupAddDx from 'component/Treatments/PopupAddDx'
import PopupEmrOverview from 'component/Treatments/PopupEmrOverview/PopupEmrOverview'
import TableCustom from 'features/treatments/MainMenu/OPD/Table/TableCustom'

/** STYLE */
import RegisterApi from 'api/counter/register.api'
import TreatmentSummaryApi from 'api/dentists/treatment-summary.api'
import TreatmentProductApi, { AllProduct } from 'api/dentists/treatmentProduct.api'
import OperativeApi from 'api/setting/treatments/operative.api'
import MedicinesApi from 'api/warehouses/medicine.api'
import { selectMe } from 'app/slice/user.slice'
import TeethAdult from 'assets/toothChart/type-teeth/teethAdult'
import TeethChild from 'assets/toothChart/type-teeth/teethChild'
import ButtonCustom from 'component/Button/ButtonCustom'
import { notiError } from 'component/notifications/notifications'
import TableRowCommon from 'component/Table/TableRowCommon'
import { PaymentInstallmentListProps, PaymentInstallmentListStatus } from 'component/Treatments/PaymentInstallment/PaymentInstallment'
import { PopupCariesRiskAssessment } from 'component/Treatments/PopupCariesRiskAssessment'
import { ButtonToothChart, ButtonTreatmentOverview, ButtonType, FragmentToothChart, FragmentTxTable, ResponsiveTxTable, TxStyled, TypeTabs } from 'features/treatments/MainMenu/OPD/style/TxUseStyle'
import { IconAddBox, IconBookmark } from 'features/treatments/MainMenu/OPD/style/UseStyle'
import { UpdateDFIF, updateDFNsho, updateDFValue } from 'features/treatments/SummaryTreatment/SummaryTreatment'
import PageModal from 'new-components/modal/page-modal'
import { dateToView } from 'utils/date.utils'



type TxType = {
  userId?: number
  patientId: number
  disabled?: boolean
  hasCreateTreatment?: 'PERMISS' | 'UNPERMISS'
  type?: 'Treatment' | 'Payment' | 'HistoryTreatment' | 'RetrospectiveOrder' | 'SettingTreatmentPlan'
  patient?: any
  date?: string
  dataPatientCase?: any
}

export default function TX(props: TxType) {
  const treatments: TreatmentStateInterface = useSelector(treatment)
  const isEditTootCharts: any = useSelector(isEditTootChart)
  const isEditTootChartTypes: any = useSelector(isEditTootChartType)
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [width] = useWindowSize()
  const modal: boolean = useSelector(handleShow)
  const branchInfo = getClinicInfo()
  const user = useSelector(selectMe)

  const [isShowPopupEmrOverview, setIsShowPopupEmrOverview] = useState<boolean>(false)
  const [cariesRiskAssessment, setCariesRiskAssessment] = useState<{ isShow: boolean, data: any }>({ isShow: false, data: {} })
  const [isShowPopupDx, setIsShowPopupDx] = useState<{ show: boolean; data: { dx: DiagnosisDataInterface[]; recommend: DxRecommendDataInterface[] }; tx: any }>({ show: false, data: { dx: [], recommend: [] }, tx: {} })
  const [numberPage, setNumberPage] = useState(0)
  const userId = props.userId
  const [operativeTypes, setOperativeTypes] = useState([])
  const [operatives, setOperatives] = useState([])
  const [typeSelected, setTypeSelected] = useState('All')
  const [isBookmark, setIsBookmark] = useState(0)
  const [typeId, setTypeId] = useState(0)
  const [selectOperativeLoading, setSelectOperativeLoading] = useState(false)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(6)
  const [rowCount, setRowCount] = useState(0)
  const [search, setSearch] = useState('')

  const [teethType, setTeethType] = useState('ADULT')
  const [doctorHidden, setDoctorHidden] = useState<boolean>(false)

  const [isShowPopupTxInstallment, setIsShowPopupTxInstallment] = useState<boolean>(false)
  const [dataTxInstallment, setDataTxInstallment] = useState<DataTxInstallment>({
    itemId: 0,
    patientId: 0,
    dataTx: {},
    resTx: undefined
  })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const newDoctor: number[] = []
    treatments?.summeryTreatments?.forEach((item: any) => {
      if (item?.isEdit === "0" && !newDoctor.includes(item.doctorId)) {
        newDoctor.push(item.doctorId)
      }
    })
    // branchInfo
    setDoctorHidden(branchInfo?.pdfInvoiceTreatmentCondition === '0' ? newDoctor.includes(user?.userId) : false)
  }, [treatments, user?.userId])

  const loadDataOperativeType = useCallback(() => {
    TreatmentApi.findAllOperativeType()
      .then(({ data }) => setOperativeTypes(data))
      .catch(() => {
        return
      })
  }, [])

  const loadData = useCallback(
    (valueUserId: number) => {
      setLoading(true)
      let condition: any = {}
      if (page) condition = { ...condition, page: page }
      if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
      if (search) condition = { ...condition, search: search }
      condition = { ...condition, userId: valueUserId }
      if (isBookmark) condition = { ...condition, isBookmark: isBookmark }
      if (typeId) condition = { ...condition, typeId: typeId }

      TreatmentApi.findAllOperative(condition)
        .then(({ headers, data }) => {
          setRowCount(headers['x-total'])
          setOperatives(data)
          setNumberPage(page)
        })
        .catch(() => {
          return
        })
    },
    [page, pageLimit, search, isBookmark, typeId]
  )

  const loadNhsoData = async () => {
    setLoading(true)
    await TreatmentSummaryApi.findTreatmentSummary(props.patient?.patientCase?.patientCaseId).then(async (resp) => {
      await RegisterApi.getMasterNhso({
        page: page,
        pageLimit: pageLimit,
        search: search
      })
        .then(({ headers, data }) => {
          setRowCount(headers['x-total'])
          setOperatives(data)
          setNumberPage(page)
          if (resp.data.summeryTreatments.length >= 0) {
            if (props.dataPatientCase?.countRecord === 1) {
              const operative = _.find(data, (item) => item.operativeCode === '2330011')
              const item = {
                ...operative,
                qty: 1
              }
              // if (window.location.pathname === '/treatments') {
              if (resp.data?.summeryTreatments?.[0]?.operativeCode !== '2330011' && treatments.summeryTreatments.length === 0) {
                dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: [...resp.data?.summeryTreatments, item] }))
              } else if (treatments.summeryTreatments?.length !== 0) {
                dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: treatments.summeryTreatments }))
              } else {
                dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: [...resp.data?.summeryTreatments] }))
              }
              // }

            }
          }
        })
        .catch(() => {
          setLoading(false)
          return
        }).finally(() => setLoading(false))
    })

  }


  useEffect(() => {
    loadDataOperativeType()
  }, [loadDataOperativeType])

  useEffect(() => {
    if (window.location?.pathname === '/retrospective-order') {
      if (props.dataPatientCase?.isNhso !== '1') {
        if (userId) {
          loadData(userId)
          handleTooltip()
          setLoading(false)
        }
      }
    } else {
      if (props.dataPatientCase?.isNhso !== '1' && props.dataPatientCase) {
        if (userId) {
          loadData(userId)
          handleTooltip()
          setLoading(false)
        }
      } else {
        if (userId) {
          loadData(userId)
          setLoading(false)

        }
      }
    }
  }, [loadData, userId, props.dataPatientCase, page, pageLimit])

  useEffect(() => {
    if (props.dataPatientCase?.isNhso === '1' && props.dataPatientCase) {
      loadNhsoData()
    }
  }, [props.dataPatientCase, page, pageLimit, search])

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }

  const handleChangeType = (ele: any) => {
    const type = ele.currentTarget.getAttribute('data-value')
    setTypeSelected(type)
    setIsBookmark(0)
    setTypeId(0)
    setPage(1)

    if (type === 'BOOKMARK') setIsBookmark(1)
    else if (type === 'All') setTypeId(0)
    else setTypeId(parseInt(type))
  }

  const handleBookmark = (id: number, bookmarkId: string) => {
    const payload: Bookmark = {
      bookmarkType: 'OPERATIVE',
      userId: userId || 0,
      itemId: id,
      isBookmark: bookmarkId ? '0' : '1'
    }

    ComponentApi.bookmark(payload)
      .then(() => loadData(userId || 0))
      .catch(() => {
        return
      })
  }

  const handleTooltip = () => {
    const textContainer = document.querySelector('.text-treatment')
    if (textContainer) {
      const textElement = textContainer.querySelector('p')
      if (textElement) {
        if (textElement.scrollWidth > textContainer.clientWidth) {
          console.log('Text is overflowing!')
        } else {
          console.log('Text is not overflowing.')
        }
      }
    }
  }

  const handleSetProducts = async (info: any, itemAdd: any) => {
    const newQty = itemAdd?.qty || 1
    let newInfo: any = {
      itemId: info?.itemId,
      itemName: info?.itemName,
      itemNameEn: info?.itemNameEn,
      itemCode: info?.itemCode,
      image: {
        fileId: info?.image?.fileId || null,
        filePath: info?.image?.filePath || '',
        fileName: info?.image?.fileName || ''
      },
      stock: info?.qty,
      defaultProductUnitName: info?.itemUnit?.itemUnitName || info?.itemUnit?.itemUnitNameEn,
      dosage: 1,
      expireDate: info?.expireDate || ''
    }
    const hasItemInSummary = _.some(treatments.summeryTreatments, (sum, index) => {
      if (!sum?.promotion?.length) {
        return sum.itemId === info.itemId
      } else {
        return sum.itemId === info.itemId && sum?.promotion.every((info: any) => info?.promotionType !== 'EXTRA')
      }
    })
    let res
    let newTemId
    if (!hasItemInSummary) {
      if (props.type !== 'RetrospectiveOrder') {
        res = await TreatmentProductApi.findStickerById(props.patient.patientCase?.patientCaseId, info?.itemId, { isCreate: '1' })
        newTemId = Math.max(...res?.data.map((item: any) => item.tempOrderProductId))
      }

      if (info?.group === "MEDICINE") {
        await MedicinesApi.findById(info?.itemId)
          .then(({ data }: any) => {
            const objSticker: StickerType = {
              ...newInfo,
              productInstructionId: data?.productInstruction?.productInstructionId,
              productInstructionName: data?.productInstruction?.productInstructionName,
              productUnitId: data?.productUnit?.productUnitId,
              productUnitName: data?.productUnit?.productUnitName,
              productUnitNameEn: data?.productUnit?.productUnitNameEn,
              productUseId: data?.productUse?.productUseId,
              productUseDetail: data?.productUse?.productUseDetail,
              logo: branchInfo?.branchLogo,
              clinicName: branchInfo?.clinicAndBranchName,
              branchAddress: branchInfo?.branchFullAddress,
              branchTel: branchInfo?.branchPhone,
              patientFullName: `${props?.patient?.firstname} ${props?.patient?.lastname}` || ''
            }
            newInfo = { ...newInfo, ...objSticker }
          })
      }

      if (props.type === 'RetrospectiveOrder') {
        const newValue: ProductStickerType = {
          sticker: JSON.stringify(newInfo),
          doctorId: 0,
          qty: newQty,
          // price: status === "EXTRA" ? 0 : info?.price,
          price: info?.price,
          discount: 0,
          discountUnit: 'BAHT',
          additional: 0,
          additionalUnit: 'BAHT',
          // total: status === "EXTRA" ? 0 : info?.price * newQty,
          total: info?.price * newQty,
          itemId: info?.itemId,
        }

        // await TreatmentProductApi.updateStickerById(props.patient.patientCase?.patientCaseId, newValue.itemId, newValue).then(() => { return }).catch(() => { return })

        return {
          ...info,
          doctorId: null,
          qty: newQty,
          price: info.price,
          discount: 0,
          discountUnit: 'BAHT',
          additional: 0,
          additionalUnit: 'BAHT',
          total: info.price,
          sticker: JSON.stringify(newInfo)
        }
      } else {
        const newValue: ProductStickerType = {
          sticker: JSON.stringify(newInfo),
          tempOrderProductId: newTemId,
          doctorId: 0,
          qty: newQty,
          // price: status === "EXTRA" ? 0 : info?.price,
          price: info?.price,
          discount: 0,
          discountUnit: 'BAHT',
          additional: 0,
          additionalUnit: 'BAHT',
          // total: status === "EXTRA" ? 0 : info?.price * newQty,
          total: info?.price * newQty,
          itemId: info?.itemId,
        }

        await TreatmentProductApi.updateStickerById(props.patient.patientCase?.patientCaseId, newValue.itemId, newValue).then(() => { return }).catch(() => { return })

        return {
          ...info,
          tempOrderProductId: newTemId,
          doctorId: null,
          qty: newQty,
          price: info.price,
          discount: 0,
          discountUnit: 'BAHT',
          additional: 0,
          additionalUnit: 'BAHT',
          total: info.price,
          sticker: JSON.stringify(newInfo)
        }
      }
    } else {
      const indexItem = _.findIndex(treatments.summeryTreatments, { itemId: info.itemId })
      const currentQty = Number(treatments.summeryTreatments[indexItem].qty) + newQty
      return { itemIdDup: info.itemId, itemIdDupIndex: indexItem, qty: currentQty, total: currentQty * info.price }
    }
  }

  const handleAddOperative = async (tx: any, installment?: boolean) => {
    if (installment) {
      /** ถ้าเข้าเงื่อนไขแบ่งจ่ายจะไม่สามารถแก้ไขอะไรได้ */
      dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: [...treatments.summeryTreatments, tx] }))
      return
    }

    const hasOverdueCondition = _.some(treatments?.summeryTreatments, { isEdit: '0', doctorId: _.get(treatments.summeryTreatments[0], 'pinDoctorId') || userId })
    const hasOverdue = branchInfo?.pdfInvoiceTreatmentCondition === '0' ? hasOverdueCondition : false
    let item = {
      ...tx,
      qty: 1,
      total: tx.price,
      doctorId: !hasOverdue ? _.get(treatments.summeryTreatments[0], 'pinDoctorId') || userId : null,
      discount: 0,
      additional: 0,
      discountUnit: 'BAHT',
      additionalUnit: 'BAHT',
      dfAmount: null,
      cfAmount: null,
      dfDiscountAmount: 0,
      cfDiscountAmount: 0,
      dfDiscountUnit: 'BAHT',
      cfDiscountUnit: 'BAHT',
      isEdit: null
    }
    if (props.type === 'SettingTreatmentPlan') {
      dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: [...treatments.summeryTreatments, item] }))
      dispatch(setColorToothChart({ value: tx.color }))
      dispatch(setSubmitTootChart(true))
      // } else if (props.dataPatientCase?.isNhso === '1') {
      //   const itemDup = [...treatments.summeryTreatments]

      //   dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: [...itemDup, item] }))
      //   dispatch(setColorToothChart({ value: tx.color }))
      //   dispatch(setSubmitTootChart(true))
    } else {
      setSelectOperativeLoading(true)
      await TreatmentApi.findOperativeById(tx.operativeId)
        .then(async ({ data }) => {
          if (!_.isEmpty(data)) {
            let dxRecommend: DxRecommendDataInterface[] = []
            _.forEach(data, (d: DiagnosisDataInterface) => {
              if (!_.isEmpty(d.diagnosisRecommends)) dxRecommend = [...dxRecommend, ...(d.diagnosisRecommends || [])]
            })
            if (props.type !== 'SettingTreatmentPlan') {
              setIsShowPopupDx({ show: true, data: { dx: data, recommend: dxRecommend }, tx: item })
            }
            dispatch(showModal())
            dispatch(setSubmitTootChart(false))
          } else {
            let itemProducts = []
            const itemDup = [...treatments.summeryTreatments]
            if (tx.operativeId) {
              const resp: any = await OperativeApi.findById(tx.operativeId)
              const data = {
                clinicFeeId: resp?.data?.operativeClinicFees[0]?.clinicFeeId,
                clinicFeeName: resp?.data?.operativeClinicFees[0]?.clinicFeeText,
                clinicFeePrice: resp?.data?.operativeClinicFees[0]?.price
              }
              const operativeProducts = resp?.data?.operativeProducts || []
              const branchId = getBranch()
              if (operativeProducts?.length) {
                const dataProducts = await Promise.all(operativeProducts.map(async (item: any) => {
                  const condition: AllProduct = { page: 1, pageLimit: 1, branchId: branchId, userId: user.userId || 0, group: item?.group, search: item?.productCode }
                  const resp = await TreatmentProductApi.findAllProduct(condition)
                  if (resp?.data[0]) {
                    const newData = await handleSetProducts(resp?.data[0], item)
                    return { ...newData }
                  } else {
                    return { errorItem: item }
                  }
                }));
                const newDataProducts = dataProducts?.filter((item) => {
                  if (item?.itemIdDup) {
                    itemDup[item.itemIdDupIndex] = { ...itemDup[item.itemIdDupIndex], qty: item.qty, total: item.total }
                  }
                  if (!item?.errorItem && !item?.itemIdDup) {
                    return item
                  }
                })
                itemProducts = newDataProducts || []
                const itemError = dataProducts.find((item) => item?.errorItem) || null
                if (itemError?.errorItem?.productName) {
                  notiError(t('TREATMENT_SUMMARY.MESSAGE.ERROR_PRODUCT_IMPORT', { productName: itemError?.errorItem?.productName }))
                }
              }

              if (item.doctorId) {
                const updateDF: UpdateDFIF | boolean = await updateDFValue({ ...item })
                if (updateDF) {
                  item = {
                    ...item,
                    total: updateDF.total,
                    dfAmount: updateDF.dfAmount,
                    dfUnit: updateDF.dfUnit,
                    cfAmount: updateDF.cfAmount,
                    dfAmountNet: updateDF.dfAmountNet,
                    cfAmountNet: updateDF.cfAmountNet,
                    doctorFeeAmount: updateDF.dfAmount,
                    clinicFeeAmount: updateDF.cfAmount,
                    promotionDiscount: updateDF.promotionDiscount,
                    dfPromotionDiscountAmount: updateDF.dfPromotionDiscountAmount,
                    cfPromotionDiscountAmount: updateDF.cfPromotionDiscountAmount,
                    voucherDiscount: updateDF.voucherDiscount,
                    dfVoucherDiscountAmount: updateDF.dfVoucherDiscountAmount,
                    cfVoucherDiscountAmount: updateDF.cfVoucherDiscountAmount,
                  }
                }
              }

              if (resp.status === 200) item = { ...item, ...data }
            }
            if (props.type === 'RetrospectiveOrder') {
              dispatch(loadPromotionTreatments(props?.patient?.patientId, [...itemDup, ...itemProducts, item,], props.date))
            } else {
              dispatch(loadPromotionTreatments(props?.patient?.patientId, [...itemDup, ...itemProducts, item,]))
            }

            let newList = [...itemDup, ...itemProducts, item]
            if (props.dataPatientCase?.isNhso === '1') {
              newList = await updateDFNsho({ list: newList, hasNoDf: "0" })

              console.log('props.dataPatientCase?.isNhso', props.dataPatientCase?.isNhso);


            }

            console.log('newList', newList);


            dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: newList }))
            dispatch(setColorToothChart({ value: tx.color }))
            dispatch(setSubmitTootChart(true))
          }
        })
        .catch((e) => {
          return
        })
        .finally(() => setSelectOperativeLoading(false))
    }
  }

  const desktopHeadCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'type', disablePadding: false, label: t('TX.TABLE.TYPE') }
  ]

  const mobileHeadCells = [{ id: 'action', disablePadding: false, label: 'Action', align: width >= 768 ? 'center' : 'right', class: 'pr-1 pr-md-3' }]

  const tableHeadCells = [
    { id: 'code', disablePadding: false, label: t('TX.TABLE.CODE'), align: 'center' },
    { id: 'service', disablePadding: false, label: t('TX.TABLE.SERVICE') },
    { id: 'unit', disablePadding: false, label: t('TX.TABLE.UNIT'), align: 'center' },
    { id: 'price', disablePadding: false, label: t('TX.TABLE.PRICE'), align: 'right' }
  ]

  const headCells = width >= 768 ? (width >= 1200 && [...desktopHeadCells, ...tableHeadCells, ...mobileHeadCells]) || [...tableHeadCells, ...mobileHeadCells] : [...mobileHeadCells]

  const renderData = (objData: any, no: number) => {
    no = numberPage * pageLimit - pageLimit + no + 1
    const { bookmarkId, operativeCode, operativeId, operativeName, operativeTypeName, operativeUnitName, price } = objData
    let tooltip = false
    const handleTooltip = () => {
      const textContainer = document.querySelector(`.text-treatment-${operativeId}`)
      if (textContainer) {
        const textElement = textContainer.querySelector('p')
        if (textElement) {
          if (textElement.scrollWidth > textContainer.clientWidth) {
            tooltip = true
          } else {
            tooltip = false
          }
        }
      }
    }

    handleTooltip()

    return (
      <TableRow key={operativeId} className={`treatment-raw-${operativeId}`}>
        {(width >= 768 && (
          <>
            {width >= 1200 && (
              <>
                <TableCell align="center" scope="row">
                  {no}
                </TableCell>
                <TableCell align="left" scope="row" className="text-ellipsis" title={operativeTypeName}>
                  {operativeTypeName}
                </TableCell>
              </>
            )}
            <TableCell align="center" scope="row" className="text-ellipsis">
              {operativeCode}
            </TableCell>
            {!tooltip && (
              <TableCell align="left" scope="row" className={`text-ellipsis text-treatment-${operativeId}`}>
                <p style={{ height: 'fit-content', marginBottom: '-0px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{operativeName}</p>
              </TableCell>
            )}
            {tooltip && (
              <Tooltip title={operativeName} placement="top">
                <TableCell align="left" scope="row" className={`text-ellipsis text-treatment-${operativeId}`}>
                  <p style={{ height: 'fit-content', marginBottom: '-0px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{operativeName}</p>
                </TableCell>
              </Tooltip>
            )}
            <TableCell align="center" scope="row" className="text-ellipsis">
              {operativeUnitName || 'ครั้ง'}
            </TableCell>
            <TableCell align="right" scope="row" className="text-ellipsis">
              {numberFormat(price)}
            </TableCell>
            <TableCell align="center" scope="row">
              <IconBookmark key={operativeId} className="p-0 mr-1" disabled={objData?.operativeTypeNameEn === 'NHSO'} onClick={() => objData?.operativeTypeNameEn !== 'NHSO' && handleBookmark(operativeId, bookmarkId)} sx={{ backgroundColor: 'transparent !important' }}>
                {bookmarkId ? <Icons.StarActive width="24" height="24" /> : <Icons.StarInActive width="24" height="24" fill={objData?.operativeTypeNameEn === 'NHSO' ? '#BBBBBB' : colors.themeSecondColor} />}
              </IconBookmark>
              <IconAddBox
                disabled={objData?.operativeCode === '2330011' ? true : (props?.hasCreateTreatment === 'PERMISS' && !doctorHidden) ? false : true}
                key={operativeId} className="p-0 ml-1"
                onClick={() => handleAddOperativeInstallment(objData)}
                sx={{ backgroundColor: 'transparent !important' }}
              >
                <AddBoxIcon style={{ width: 30, height: 30 }} />
              </IconAddBox>
            </TableCell>
          </>
        )) || (
            <>
              <TableCell align="left" scope="row">
                <Box className="d-flex justify-content-between">
                  <Box>
                    <Typography className="d-inline-block mr-3" sx={{ width: '85px', fontWeight: 600 }}>
                      {t('TX.TABLE.CODE')}
                    </Typography>
                    <Typography className="d-inline">{operativeCode}</Typography>
                  </Box>
                  <Box>
                    <IconBookmark key={operativeId} className="p-0 mr-1" disabled={objData?.operativeTypeNameEn === 'NHSO'} onClick={() => objData?.operativeTypeNameEn !== 'NHSO' && handleBookmark(operativeId, bookmarkId)} sx={{ backgroundColor: 'transparent !important' }}>
                      {bookmarkId ? <Icons.StarActive width="24" height="24" /> : <Icons.StarInActive width="24" height="24" fill={objData?.operativeTypeNameEn === 'NHSO' ? '#BBBBBB' : colors.themeSecondColor} />}
                    </IconBookmark>
                    <IconAddBox disabled={props?.hasCreateTreatment === 'PERMISS' ? false : true} key={operativeId} className="p-0 ml-1" onClick={() => handleAddOperativeInstallment(objData)} sx={{ backgroundColor: 'transparent !important' }}>
                      <AddBoxIcon style={{ width: 30, height: 30 }} />
                    </IconAddBox>
                  </Box>
                </Box>
                <Box>
                  <Typography className="d-inline-block mr-3" sx={{ width: '85px', fontWeight: 600 }}>
                    {t('TX.TABLE.SERVICE')}
                  </Typography>
                  {!tooltip && (
                    <Typography className={`d-inline text-treatment-${operativeId}`}>{operativeName}</Typography>
                  )}
                  {tooltip && (
                    <Tooltip title={operativeName} placement="top">
                      <Typography className={`d-inline text-treatment-${operativeId}`}>{operativeName}</Typography>
                    </Tooltip>
                  )}
                </Box>
                <Box>
                  <Typography className="d-inline-block mr-3" sx={{ width: '85px', fontWeight: 600 }}>
                    {t('TX.TABLE.UNIT')}
                  </Typography>
                  <Typography className="d-inline">{operativeUnitName}</Typography>
                </Box>
                <Box>
                  <Typography className="d-inline-block mr-3" sx={{ width: '85px', fontWeight: 600 }}>
                    {t('TX.TABLE.PRICE')}
                  </Typography>
                  <Typography className="d-inline">{numberFormat(price)}</Typography>
                </Box>
              </TableCell>
            </>
          )}
      </TableRow>
    )
  }

  const onViewEmrOverview = () => {
    dispatch(showModal())
    dispatch(setEditTootChart(null))
    dispatch(setEditTootChartType(''))
    setIsShowPopupEmrOverview(true)
  }
  const onChangeCariesRiskAssessment = async () => {
    const { data } = await TreatmentApi.findDentalRiskAssessments(props.patient?.patientCase?.patientCaseId)
    dispatch(showModal())
    setCariesRiskAssessment({ isShow: true, data })
  }

  const handleAddOperativeInstallment = async (tx: any) => {
    const itemId = tx?.operativeId || 0
    const patientId = props?.patient?.patientId || 0


    if (props?.type === 'Treatment' || props?.type === 'Payment') {
      /** เช็คเงื่อนไข กรณีเลือกหัตถการที่มีการแบ่งจ่าย ต้องจ่ายให้ครบก่อน หรือลบเพิ่ม เพิ่มรายการใหม่ */
      const resTx = await loadTxinstallment(patientId, itemId)

      const handleCheckTx = () => {
        if (resTx && resTx.data?.length) {
          const itemCount = treatments?.summeryTreatments?.filter((i: any) => i.operativeId === itemId)
          if (itemCount?.length) {
            const check = resTx.data.every((item: any) => {
              return item.operativeId === itemId && itemCount?.some((info: any) => info?.installmentPaymentId === item?.installmentPaymentId)
            })
            return !check
          } else {
            return true
          }
        } else {
          return false
        }
      }

      const checkTx = handleCheckTx()

      if (checkTx) {
        /** if เข้าเงื่อนไขแบ่งจ่าย */
        setIsShowPopupTxInstallment(true)
        setDataTxInstallment({ patientId, itemId, dataTx: tx, resTx: resTx.data })
      } else {
        /** else ไม่เข้าเงื่อนไขแบ่งจ่าย */
        await handleAddOperative(tx)
      }

      return
    }
    await handleAddOperative(tx)
  }

  const loadTxinstallment = async (patientId: number, itemId: number) => {
    const res = await TreatmentApi.findInstallmentTx(patientId, itemId)
    return res
  }

  useEffect(() => {
    if (!modal) {
      setIsShowPopupEmrOverview(false)
      setIsShowPopupDx({ show: false, data: { dx: [], recommend: [] }, tx: {} })
      dispatch(resetModal())
    }
  }, [modal])

  useEffect(() => {
    if (isEditTootChartTypes) {
      setTeethType(isEditTootChartTypes)
    }
  }, [isEditTootChartTypes])
  return (
    <div className="w-100 h-100">
      <Loading show={loading} />
      <TxStyled className={`${props.disabled ? 'tx-disabled' : ''}`}>
        {clinicTheme.theme === clinicTheme.type.DENTAL && (
          <FragmentToothChart className="mx-auto mb-3 mb-md-5 mb-xl-0" sx={{ flex: 'none' }}>
            <Box className="d-none d-md-block">
              <ToothChart type={'treatment'} teethType={teethType} patientId={props.patientId} isRetrospectiveOrder={props.type === 'RetrospectiveOrder'} />
            </Box>
            <Box className="d-flex justify-content-center">
              <ButtonToothChart onClick={() => setTeethType('ADULT')} className="mt-0 mt-md-3 " sx={{ flex: 'none' }}>
                <TeethAdult type={teethType} />
              </ButtonToothChart>
              <ButtonToothChart onClick={() => setTeethType('CHILD')} className="mt-0 mt-md-3 pl-1 pr-3" sx={{ flex: 'none' }}>
                <TeethChild type={teethType} />
              </ButtonToothChart>
              {props.type !== 'SettingTreatmentPlan' && (
                <>
                  <ButtonTreatmentOverview variant={'outlined'} onClick={onViewEmrOverview} size="small" className="mt-0 mt-md-3 pl-1 pr-3 " sx={{ marginRight: 1 }} disabled={props.disabled || props.dataPatientCase?.isNhso === '1'}>
                    {t('OPD.BUTTON.TREATMENT_OVERVIEW')}
                  </ButtonTreatmentOverview>
                  {props.type !== 'RetrospectiveOrder' && <ButtonTreatmentOverview color='primary' variant={'outlined'} onClick={onChangeCariesRiskAssessment} size="small" className="mt-0 mt-md-3  pl-1 px-3" disabled={props.disabled}>
                    แบบประเมินฟันผุ
                  </ButtonTreatmentOverview>}
                </>
              )}
            </Box>
          </FragmentToothChart>
        )}
        {clinicTheme.theme !== clinicTheme.type.DENTAL && (
          <ButtonCustom onClick={onViewEmrOverview} disabled={props.disabled} textButton={t('OPD.BUTTON.TREATMENT_OVERVIEW')} className="d-md-none w-100 px-3" style={{ margin: 0 }} btnStyle={{ height: '36px' }} />
        )}
        <FragmentTxTable className={`${isEditTootCharts !== null || props.disabled ? 'tx-table-disabled pe-none' : ''}`}>
          <Box className="d-flex justify-content-between align-items-center pb-2">
            <Typography sx={{ fontSize: 18, fontWeight: 500, flex: 'none' }}>{t('OPD.TITLE.TX_TYPE')}</Typography>
            <Box className="d-flex align-items-center justify-content-end" sx={{ flex: 1 }}>
              {clinicTheme.theme !== clinicTheme.type.DENTAL && (
                <ButtonCustom onClick={onViewEmrOverview} disabled={props.disabled} textButton={t('OPD.BUTTON.TREATMENT_OVERVIEW')} className="px-3 d-none d-md-flex" style={{ margin: 0 }} btnStyle={{ height: '32px' }} />
              )}
              <Box className="w-100 pl-3" sx={{ maxWidth: 379 }}>
                <InputTextSearch
                  keyInput={'search'}
                  label={t('OPD.SEARCH')}
                  value={search}
                  onchange={(event) => {
                    setSearch(event.target.value)
                    setPage(1)
                  }}
                  onClear={(event) => {
                    setSearch('')
                    setPage(1)
                  }}
                />
              </Box>
            </Box>
          </Box>
          {props.dataPatientCase?.isNhso !== '1' && <TypeTabs className="d-flex flex-wrap custom-scroll">
            <Box className="px-1 pb-2">
              <ButtonType variant="outlined" title={t('ALL')} className={`${typeSelected === 'All' ? 'active' : ''} overflow-hidden`} data-value={'All'} onClick={handleChangeType} key={`btn-operative-typ-all`}>
                <span className="text-ellipsis">{t('ALL')}</span>
              </ButtonType>
            </Box>
            <Box className="px-1 pb-2">
              <ButtonType variant="outlined" title={t('BOOKMARK')} className={`${typeSelected === 'BOOKMARK' ? 'active' : ''}`} data-value={'BOOKMARK'} onClick={handleChangeType} key={`btn-operative-typ-bookmark`}>
                {isBookmark ? <Icons.StarActive fill={colors.white} /> : <Icons.StarInActive fill={colors.textPrimary} />}
              </ButtonType>
            </Box>
            {operativeTypes.map((val: any, i) => {
              return (
                <Box key={`col-operative-typ-${val.operativeTypeId}`} className="px-1 pb-2">
                  <ButtonType
                    variant="outlined"
                    key={val.operativeTypeId}
                    title={val.operativeTypeName || val.operativeTypeNameEn}
                    data-value={val.operativeTypeId}
                    onClick={handleChangeType}
                    className={`${typeSelected === val.operativeTypeId.toString() ? 'active' : ''} text-ellipsis`}
                  >
                    <span className="text-ellipsis">{val.operativeTypeName || val.operativeTypeNameEn}</span>
                  </ButtonType>
                </Box>
              )
            })}
          </TypeTabs>}
          <ResponsiveTxTable className="mt-2">
            <TableCustom
              page={page}
              pageLimit={pageLimit}
              setPageLimit={handleChangeRowsPerPage}
              setPage={handleChangePage}
              rowCount={rowCount}
              headCells={headCells}
              rowsData={operatives.map((val, i) => {
                return renderData(val, i)
              })}
            />
          </ResponsiveTxTable>
        </FragmentTxTable>
      </TxStyled>

      {
        cariesRiskAssessment.isShow && (
          <PopupCariesRiskAssessment
            {...cariesRiskAssessment}
            patientCaseId={props.patient?.patientCase?.patientCaseId}
            onReset={() => setCariesRiskAssessment({ isShow: false, data: null })}
          />
        )
      }

      {isShowPopupEmrOverview && (
        <PopupEmrOverview
          patientId={props.patientId}
          onClose={() => {
            setIsShowPopupEmrOverview(false)
            dispatch(resetModal())
          }}
        />
      )}

      {isShowPopupDx.show && (
        <PopupAddDx
          type="tx"
          tx={isShowPopupDx.tx}
          dx={{}}
          data={{ dx: isShowPopupDx.data.dx, recommend: isShowPopupDx.data.recommend }}
          isShow={isShowPopupDx.show}
          setIsShow={(show: boolean) => setIsShowPopupDx({ show, tx: {}, data: { dx: [], recommend: [] } })}
          patient={props?.patient}
        />
      )}

      <TxInstallmentBox
        data={dataTxInstallment}
        ispopup={{ open: isShowPopupTxInstallment, onClose: setIsShowPopupTxInstallment }}
        handleAddOperative={handleAddOperative}
      />

      <Loading show={selectOperativeLoading} type={'fullLoading'} />
    </div>
  )
}

export interface DataResTx {
  InstallmentPaidDate: string;
  installmentPaymentId: number;
  installment: {
    refType: "ORDER" | "TEMP_ORDER"
    status: PaymentInstallmentListStatus
    totalPrice: number
    installmentList: PaymentInstallmentListProps[]
  }
}
export interface DataTxInstallment {
  itemId: number
  patientId: number
  dataTx: unknown
  resTx: DataResTx[] | undefined
}

interface TxInstallmentBoxProps {
  data: DataTxInstallment
  ispopup: { open: boolean, onClose: React.Dispatch<React.SetStateAction<boolean>> }
  handleAddOperative: (tx: any, installment?: boolean) => void
}

const TxInstallmentBox = (props: TxInstallmentBoxProps) => {
  const { t } = useTranslation()

  const { data, ispopup, handleAddOperative } = props
  const { open, onClose } = ispopup
  const treatments: TreatmentStateInterface = useSelector(treatment)

  const [txSelect, setTxSelect] = useState<number>(0)

  const isDataTx = (obj: unknown): obj is Record<string, any> => {
    return typeof obj === 'object' && obj !== null;
  }

  const renderDataTx = (key: string) => {
    if (isDataTx(data?.dataTx) && key in data?.dataTx) {
      return data.dataTx[key]
    }
    return ''
  }

  const headCells = [
    { id: 'paidDate', label: t('INSTALLMENT.POPUP_ADD_TREATMENT.TABLE.PAID_DATE'), align: 'center', width: 'fit-content', className: 'text-nowrap' },
    { id: 'total', label: t('INSTALLMENT.POPUP_ADD_TREATMENT.TABLE.TOTAL'), align: 'center', width: 'fit-content', className: 'text-nowrap' },
    { id: 'peddingPayment', label: t('INSTALLMENT.POPUP_ADD_TREATMENT.TABLE.PEDDING'), align: 'center', width: 'fit-content', className: 'text-nowrap' },
    { id: 'count', label: t('INSTALLMENT.POPUP_ADD_TREATMENT.TABLE.COUNT'), align: 'center', width: 'fit-content', className: 'text-nowrap' },
    { id: 'action', label: t('Action'), align: 'center', width: 'fit-content', className: 'text-nowrap' },
  ]

  const renderDataTable = (objData: DataResTx, index: number) => {
    const { InstallmentPaidDate, installmentPaymentId, installment } = objData
    let paidCurrent = 0
    let paidSuccess = 0
    installment.installmentList.forEach((item) => {
      if (item.status === PaymentInstallmentListStatus.PENDING) {
        paidCurrent += item.price
      } else if (item.status === PaymentInstallmentListStatus.PAID) {
        paidSuccess += 1
      }

    })
    const paidCount = `${paidSuccess}/${installment.installmentList.length}`
    const isDisabled = treatments.summeryTreatments.some((item: any) => item?.installmentPaymentId === installmentPaymentId) || txSelect === installmentPaymentId

    const objRenderData = {
      key: (index + 1).toString(),
      id: installmentPaymentId.toString(),
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: dateToView(InstallmentPaidDate) || '-', class: 'text-nowrap' },
        { option: 'TEXT', align: 'center', label: numberFormat(installment?.totalPrice || 0), class: 'text-nowrap' },
        { option: 'TEXT', align: 'center', label: numberFormat(paidCurrent), class: 'text-nowrap' },
        { option: 'TEXT', align: 'center', label: paidCount, class: 'text-nowrap' },
        {
          option: 'COMPONENT', component: (
            <Box textAlign={'center'} sx={{ filter: isDisabled ? 'grayscale(1)' : '', opacity: isDisabled ? '0.65' : '' }}>
              <IconButton onClick={() => !isDisabled && setTxSelect((prev) => installmentPaymentId)}>
                <Box bgcolor={colors.themeSecondColor} color={isDisabled ? '#000000' : '#fff'} borderRadius={'4px'} width={'35px'} height={'35px'}>
                  <Box sx={{
                    height: '28px',
                    fontSize: '30px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '300'
                  }}>
                    +
                  </Box>

                </Box>
              </IconButton>
            </Box>
          )
        },
      ]
    }

    return <TableRowCommon {...objRenderData} />
  }

  useEffect(() => {
    if (!open) {
      setTxSelect(0)
    }
  }, [open])

  return (
    <PageModal
      isOpen={open}
      handleClose={() => onClose(false)}
      size='S'
      title={t('INSTALLMENT.POPUP_ADD_TREATMENT.TITLE')}
      btnLeft={{
        onClick: () => {
          handleAddOperative(data?.dataTx)
          onClose(false)
        },
        title: t('INSTALLMENT.POPUP_ADD_TREATMENT.BUTTON.ADD'),
        sx: { textWrap: 'nowrap', width: 'fit-content' }
      }}
      onCancel={{ onClick: () => onClose(false) }}
      onSubmit={{
        onClick: () => {
          if (data.resTx) {
            const newTx = data.resTx.find((item) => item.installmentPaymentId === txSelect)
            const newTotal = newTx?.installment.installmentList.find((item: any) => item.status === PaymentInstallmentListStatus.PENDING)?.price || 0
            handleAddOperative({ ...newTx, total: newTotal }, true)
          }
          onClose(false)
        }, disabled: !txSelect
      }}
    >
      <Box marginTop={'16px'} className='tx-installment' sx={{ '.css-1o2jhdo': { button: { width: 'auto' } }, '.css-10egq61': { button: { width: '120px' } } }}>
        <Box display='flex' gap={'16px'}>
          <Typography fontWeight={500}>
            {t('INSTALLMENT.POPUP_CHANGE.OP_CODE')}: {` ${renderDataTx('operativeCode')}`}
          </Typography>
          <Typography fontWeight={500}>
            {t('INSTALLMENT.POPUP_CHANGE.OP_NAME')}: {` ${renderDataTx('operativeName')}`}
          </Typography>
        </Box>
        <Box marginTop={'16px'}>
          <TableCustom
            page={1}
            pageLimit={99}
            setPage={() => console.log()}
            setPageLimit={() => console.log()}
            rowCount={99}
            headCells={headCells}
            rowsData={data.resTx ? data.resTx.map((item, index) => renderDataTable(item, index)) : []}
            hidePagination
          />
        </Box>

      </Box>
    </PageModal >

  )
}
